// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/cookie-policy/cookie-policy.component.scss
// module id = 67
// module chunks = 0